import { PathResponse } from "@repo/shared-types";
import bbox from "@turf/bbox";

type PathWithGeoJson = Pick<PathResponse, "geoJson">;

export type Bounds = {
  minLat: number;
  minLng: number;
  maxLat: number;
  maxLng: number;
};

export function getBounds(data: PathWithGeoJson[]): Bounds {
  return data.reduce(
    (acc, { geoJson }) => {
      const [bboxMinLng, bboxMinLat, bboxMaxLng, bboxMaxLat] = bbox(geoJson);
      acc.minLng = Math.min(acc.minLng, bboxMinLng);
      acc.minLat = Math.min(acc.minLat, bboxMinLat);
      acc.maxLng = Math.max(acc.maxLng, bboxMaxLng);
      acc.maxLat = Math.max(acc.maxLat, bboxMaxLat);
      return acc;
    },
    { minLng: Infinity, minLat: Infinity, maxLng: 0, maxLat: 0 }
  );
}
